// @ts-nocheck
// ----------------------------------------------------------------------

function pxToRem(value) {
  return `${value / 16}rem`;
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm)
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md)
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg)
    }
  };
}

// Phones (xs, <600px) read a touch small at desktop sizes, so we bump each UI
// text role up by ~1px on phones and restore the original size from sm upward.
// Desktop/tablet is left exactly as it was.
function mobileBump(mobile, desktop) {
  return {
    fontSize: pxToRem(mobile),
    '@media (min-width:600px)': {
      fontSize: pxToRem(desktop)
    }
  };
}

// Plus Jakarta Sans — a premium geometric grotesk for an Apple/Linear-tier feel.
// Public Sans is kept as the graceful fallback while the webfont loads.
const FONT_PRIMARY = '"Plus Jakarta Sans", "Public Sans", sans-serif'; // Google Font

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    letterSpacing: '-0.03em',
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 })
  },
  h2: {
    fontWeight: 800,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    letterSpacing: '-0.025em',
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 })
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.45,
    fontSize: pxToRem(24),
    letterSpacing: '-0.02em',
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 })
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    letterSpacing: '-0.015em',
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 })
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(19),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 })
  },
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 })
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    ...mobileBump(17, 16)
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    ...mobileBump(15, 14)
  },
  body1: {
    lineHeight: 1.5,
    ...mobileBump(17, 16)
  },
  body2: {
    lineHeight: 22 / 14,
    ...mobileBump(15, 14)
  },
  caption: {
    lineHeight: 1.5,
    ...mobileBump(13, 12)
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: 1.1,
    textTransform: 'uppercase',
    ...mobileBump(13, 12)
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    textTransform: 'capitalize',
    ...mobileBump(15, 14)
  }
};

export default typography;